/*
 * @Author: ypf2345678 1278729153@qq.com
 * @Date: 2023-07-21 14:45:16
 * @LastEditors: ypf2345678 1278729153@qq.com
 * @LastEditTime: 2023-07-26 16:01:48
 * @FilePath: /npm-component/src/package/group/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Module from './src/indexA.vue'
Module.install = Vue =>{
  Vue.component(Module.name,Module)
}
export default Module